import { render, staticRenderFns } from "./plugin-group-entities-search.vue?vue&type=template&id=f3a1fb54&scoped=true&"
import script from "./plugin-group-entities-search.vue?vue&type=script&lang=js&"
export * from "./plugin-group-entities-search.vue?vue&type=script&lang=js&"
import style0 from "./plugin-group-entities-search.vue?vue&type=style&index=0&id=f3a1fb54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a1fb54",
  null
  
)

export default component.exports